import { render, staticRenderFns } from "./CourseReplayPage.vue?vue&type=template&id=ea98f208&scoped=true"
import script from "./CourseReplayPage.vue?vue&type=script&lang=js"
export * from "./CourseReplayPage.vue?vue&type=script&lang=js"
import style0 from "./CourseReplayPage.vue?vue&type=style&index=0&id=ea98f208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea98f208",
  null
  
)

export default component.exports